import { lazy, Suspense } from 'react';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';

import { useAuth } from '@/shared/auth/context';
import { LoadingScreen } from '@/shared/ui/LoadingScreen';

const AuthLayout = lazy(() => import('@/features/auth/components/AuthLayout').then((module) => ({ default: module.AuthLayout })));
const LoginPage = lazy(() => import('@/features/auth/pages/LoginPage').then((module) => ({ default: module.LoginPage })));
const RegisterPage = lazy(() => import('@/features/auth/pages/RegisterPage').then((module) => ({ default: module.RegisterPage })));
const VerifyPage = lazy(() => import('@/features/auth/pages/VerifyPage').then((module) => ({ default: module.VerifyPage })));
const DashboardPage = lazy(() => import('@/features/dashboard/pages/DashboardPage').then((module) => ({ default: module.DashboardPage })));
const ExchangePage = lazy(() => import('@/features/exchange/pages/ExchangePage').then((module) => ({ default: module.ExchangePage })));
const MovementsPage = lazy(() => import('@/features/movements/pages/MovementsPage').then((module) => ({ default: module.MovementsPage })));
const ReceivePage = lazy(() => import('@/features/receive/pages/ReceivePage').then((module) => ({ default: module.ReceivePage })));
const TransferPage = lazy(() => import('@/features/transfers/pages/TransferPage').then((module) => ({ default: module.TransferPage })));
const SupportPage = lazy(() => import('@/features/support/pages/SupportPage').then((module) => ({ default: module.SupportPage })));
const KycPage = lazy(() => import('@/features/kyc/pages/KycPage').then((module) => ({ default: module.KycPage })));
const PrivateLayout = lazy(() => import('./layout/PrivateLayout').then((module) => ({ default: module.PrivateLayout })));
const NotFoundPage = lazy(() => import('./views/NotFoundPage').then((module) => ({ default: module.NotFoundPage })));

function RequireAuth() {
  const { session } = useAuth();
  const location = useLocation();
  return session ? <Outlet /> : <Navigate to="/login" replace state={{ from: location.pathname }} />;
}

export function AppRouter() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify" element={<VerifyPage />} />
        </Route>
        <Route element={<RequireAuth />}>
          <Route element={<PrivateLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="/enviar" element={<TransferPage />} />
            <Route path="/recibir" element={<ReceivePage />} />
            <Route path="/intercambio" element={<ExchangePage />} />
            <Route path="/movimientos" element={<MovementsPage />} />
            <Route path="/soporte" element={<SupportPage />} />
            <Route path="/kyc" element={<KycPage />} />
            <Route path="/kyc/users" element={<Navigate to="/kyc" replace />} />
            <Route path="/kyc/:section" element={<KycPage />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
